<div class="dialog-container">
  <button
    mat-icon-button
    mat-dialog-close="cancel"
    aria-label="Close dialog"
    class="close-icon"
  >
    <span class="material-symbols-outlined">close</span>
  </button>
  <span class="material-symbols-outlined warning-icon">warning_amber</span>
  <div class="confirmation-title">
    {{ "leavePageConfirmation" | translate }}
  </div>
  <div class="confirmation-subtitle">
    {{ "unsavedChangesConfirmation" | translate }}
  </div>
  <div class="confirmation-subtitle">
    {{ "unsavedChangesWarning" | translate }}
  </div>
  <mat-dialog-actions align="center">
    <button mat-flat-button class="cancel-button" mat-dialog-close="cancel">
      {{ "cancel" | translate }}
    </button>
    <button
      mat-flat-button
      class="cancel-button"
      [mat-dialog-close]="'discard'"
    >
      {{ "discard" | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      class="save-button"
      [mat-dialog-close]="'save'"
    >
      {{ "saveChanges" | translate }}
    </button>
  </mat-dialog-actions>
</div>
